export const FETCH_SCRIPT_HEADERS = {
  "Accept": "application/javascript",
  "Content-Type": "application/json",
};

const ACCEPT_JSON_HEADERS = {
  Accept: "application/json",
};

const JSON_REQUEST_HEADERS = {
  ...ACCEPT_JSON_HEADERS,
  "Content-Type": "application/json",
};

const FORM_REQUEST_HEADERS = {
  ...ACCEPT_JSON_HEADERS,
  "Content-Type": "application/x-www-form-urlencoded",
};

export async function postAndAppendScript(url, data) {
  const options = {
    method: "POST",
    headers: FETCH_SCRIPT_HEADERS,
    body: JSON.stringify(data),
  };

  const response = await fetch(url, options);
  const script = await response.text();

  appendScript(script);
}

export function appendScript(data) {
  const script = document.createElement("script");
  script.text = data;
  document.body.appendChild(script);
}

async function parseJsonResponse(response) {
  if (response.status === 204) {
    return null;
  }

  const contentType = response.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json") || contentType.includes("+json");

  if (!isJson) {
    return null;
  }

  try {
    return await response.json();
  } catch {
    return null;
  }
}

export async function requestJson(url, options = {}) {
  const defaultHeaders =
    typeof options.body === "string" ? JSON_REQUEST_HEADERS : ACCEPT_JSON_HEADERS;

  const response = await fetch(url, {
    ...options,
    headers: { ...defaultHeaders, ...options.headers },
  });

  const data = await parseJsonResponse(response);

  return { response, data };
}

export async function fetchJson(url, options = {}) {
  return requestJson(url, {
    method: "GET",
    ...options,
  });
}

export async function submitForm(url, data, options = {}) {
  const body = data instanceof URLSearchParams ? data : new URLSearchParams(data);

  return requestJson(url, {
    method: "POST",
    ...options,
    headers: { ...FORM_REQUEST_HEADERS, ...options.headers },
    body,
  });
}

export const fetchScript = async (url, options = {}) => {
  // For FormData, don't set Content-Type (browser will set it)
  const isFormData = options.body instanceof FormData;
  const defaultHeaders = isFormData ? { Accept: "application/javascript" } : FETCH_SCRIPT_HEADERS;

  options.headers = { ...defaultHeaders, ...options.headers };

  const response = await fetch(url, options);

  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }

  const script = await response.text();
  appendScript(script);
};
